/**
 * Generated file
 * Do not edit directly
 */
import React from 'react';
import { Icon, IconProps } from '@chakra-ui/react';

export const AlertSolidIcon = ({ css, ...props }: IconProps) => {
  return (
    <Icon
      height="24px"
      width="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11 14V6H13V14H11ZM12 17.9862C12.6904 17.9862 13.25 17.4266 13.25 16.7362C13.25 16.0459 12.6904 15.4862 12 15.4862C11.3097 15.4862 10.75 16.0459 10.75 16.7362C10.75 17.4266 11.3097 17.9862 12 17.9862Z"
        fill="currentColor"
      ></path>
    </Icon>
  );
};
